var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.397498 0.402728C0.927495 -0.134243 1.78679 -0.134243 2.31679 0.402728L9.5 7.68046L16.6832 0.402727C17.2132 -0.134244 18.0725 -0.134244 18.6025 0.402727C19.1325 0.939698 19.1325 1.8103 18.6025 2.34727L10.4596 10.5973C9.92965 11.1342 9.07035 11.1342 8.54036 10.5973L0.397498 2.34727C-0.132499 1.8103 -0.132499 0.939699 0.397498 0.402728Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveBack);
export default __webpack_public_path__ + "static/media/live-back.693506d465d59270223cf87d74b0fdcb.svg";
export { ForwardRef as ReactComponent };